'use client'
import { type FC, useCallback, useEffect, useRef } from 'react'
import { useMount } from '@/hooks'
import { SliderFlickity } from './commons'
import { SectionLinksSlider } from './SectionNavLinks'

type Props = {
  data: {
    id: string,
    title: string
    ref: React.RefObject<HTMLElement>
  }[]
}

const staticOptions = {
  draggable: true,
  pageDots: false
}

export const SectionAnchors: FC<Props> = ({ data }) => {
  const isMount = useMount()
  const dataRef = useRef(data)

  useEffect(() => { dataRef.current = data }, [data])

  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    e.stopPropagation()
    const href = e.currentTarget.getAttribute('href')
    dataRef.current.find(d => d.id === href)?.ref.current?.scrollIntoView({ behavior: 'smooth' })
  }, [])

  return (
    <SectionLinksSlider $isMount={isMount}>
      <nav aria-label='Internal links'>
        {data?.length > 0 &&
          <SliderFlickity options={{ ...staticOptions, cellAlign: 'center' }}>
            {data.map((item, index) => (
              <a key={index + item.id} href={item.id} onClick={handleClick}>{item.title}</a>
            ))}
          </SliderFlickity>
        }
      </nav>
    </SectionLinksSlider>
  )
}
